// @flow

import {
  PROP_PARENT,
  PROP_SEASON,
  PROP_ASSET_ID,
} from 'fc-model-assets'

// Utils
import traverse from 'fc-utils/traverse'

// Libs
import { createSelector } from 'reselect'
import _forEach from 'lodash/forEach'
import _filter from 'lodash/filter'

// Selectors
import { farms$, fields$ } from 'fc-assets'
import { selectedSeasonId$ } from 'hfty-seasons'

export default createSelector(
  [farms$, fields$, selectedSeasonId$],
  function (farms: Array<Object>, fields: Array<Object>, currSeason: number): Object {
    let returnObj = {}
    _forEach((farms: Array<Object>), (farm: Object) => {
      return returnObj[farm[PROP_ASSET_ID]] = _filter((fields: Array<Object>), (field: Object) => {
        return (field[PROP_PARENT] === farm[PROP_ASSET_ID] && field[PROP_SEASON] === currSeason)
          ? field[PROP_ASSET_ID]
          : false
      })
    })
    return returnObj
  }
)
